module.exports = __webpack_public_path__ + "img/the-netherlands-infectious-diseases-female.c524337f.png";